import { createGlobalStyle } from 'styled-components';

const GlobalRules = createGlobalStyle`
    :root {
        --main-color: #19c8fa;
        --transparent-color: rgb(15 116 143 / 70%);
        --section-padding: 100px;
    }
    * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
    }
    html {
        scroll-behavior: smooth;
    }
    body {
        font-family: "Open Sans", sans-serif;
    }
    ul {
        list-style: none;
    }
`;
export default GlobalRules;
